import { atom, useAtom } from "jotai";
import { NewTicketPopupProps } from "../../modules/communication/components/NewTicketPopup";
import { PatientDocumentScheduleId, PatientId } from "../schema/schema";

export type NewRnPlatformEmailPopupProps = NewTicketPopupProps & {
  defaultValues: {
    caregiverId: null;
    patientId: PatientId | null;
    topic: "Patient";
  };
  patientDocumentIds?: PatientDocumentScheduleId[];
};

const defaultProps: NewRnPlatformEmailPopupProps = {
  initialLabelId: null,
  defaultValues: {
    caregiverId: null,
    patientId: null,
    topic: "Patient",
  },
  defaultTicketType: "Email",
  patientDocumentIds: [],
};

const newTicketAtom = atom<NewRnPlatformEmailPopupProps | null>(null);

export function useNewRnPlatformEmail() {
  const [state, setState] = useAtom(newTicketAtom);

  const onOpen = (params?: NewRnPlatformEmailPopupProps) =>
    setState({ ...(params ?? defaultProps) });
  const onClose = () => setState(null);

  return { state, onOpen, onClose };
}
